import cn from 'classnames';

interface SliderArrowsProps {
  prevRef: React.MutableRefObject<HTMLDivElement>;
  nextRef: React.MutableRefObject<HTMLDivElement>;
  className: string;
}

export default function SliderArrows(props: SliderArrowsProps) {
  const { prevRef, nextRef, className } = props;
  const arrowCss =
    'lg:absolute top-1/2 z-[11] w-0 lg:w-14 h-0 lg:h-14 bg-white hover:bg-gray-700 rounded-full border-0 lg:border lg:border-gray-700 transition-all duration-500 -translate-y-1/2 cursor-pointer hover:fill-white scale-90 hover:scale-105 flex items-center justify-center select-none';
  const arrowInnerCss = 'hidden w-3 lg:block';

  return (
    <>
      <div ref={prevRef} className={cn('-left-6', arrowCss, className)}>
        <div className={arrowInnerCss}>
          <svg viewBox="0 0 100 100">
            <path
              d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
              transform="translate(0, 0) rotate(0) "
            />
          </svg>
        </div>
      </div>
      <div ref={nextRef} className={cn('-right-6', arrowCss, className)}>
        <div className={arrowInnerCss}>
          <svg viewBox="0 0 100 100">
            <path
              d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
              transform="translate(100, 100) rotate(180) "
            />
          </svg>
        </div>
      </div>
    </>
  );
}
